// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatCreateStandaloneBody = {
  requestId: string;
  title: string;
  photoMediaId?: string | null;
  memberUserIds: string[];
};

export type typeChatCreateStandaloneOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { chatId: string };
};

export type typeChatCreateStandaloneOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatCreateStandaloneOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatCreateStandaloneOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatCreateStandaloneBody = {
  type: "object",
  properties: {
    requestId: { type: "string", maxLength: 3000, minLength: 1 },
    title: { type: "string", maxLength: 3000, minLength: 1 },
    photoMediaId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    memberUserIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["requestId", "title", "memberUserIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatCreateStandalone(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatCreateStandaloneBody);
  }

  return async function postChatCreateStandalone(
    payload: typeChatCreateStandaloneBody,
  ): Promise<
    typeChatCreateStandaloneOutput200 | typeChatCreateStandaloneOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatCreateStandalone" failed before calling the network. #21494f02372d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#21494f02372d" },
        },
        data: null,
      } as typeChatCreateStandaloneOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/create-standalone`,
      httpMethod: "POST",
      options,
    })) as
      typeChatCreateStandaloneOutput200 | typeChatCreateStandaloneOutput400;
  };
}
